/* GOOTER Produktwelt - Data + App (locale-aware DE/EN) - facts-2026-10-05 */
(function(){
  if (window.GOOTER_PW_BOUND) return;
  window.GOOTER_PW_BOUND = true;

  /* ---- Locale detection ---- */
  var rootEl = document.querySelector('[data-gooter-produktwelt]');
  var LOC = ((rootEl && rootEl.getAttribute('data-locale')) || document.documentElement.lang || 'de').slice(0,2).toLowerCase();
  var IS_EN = LOC === 'en';
  /* ---- Base URL prefix for locale-aware internal links ---- */
  var BASE_URL = (rootEl && rootEl.getAttribute('data-base-url')) || '';
  if (BASE_URL === '/') BASE_URL = '';
  if (BASE_URL.length && BASE_URL.charAt(BASE_URL.length - 1) === '/') BASE_URL = BASE_URL.slice(0, -1);
  /* Fallback: derive locale prefix from URL pathname when data attribute is missing
     (e.g. cached server render) so that /en/ URLs still produce /en/products/... links. */
  if (!BASE_URL) {
    try {
      var _pn = (window.location && window.location.pathname) || '';
      var _m = _pn.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/i);
      if (_m) {
        var _candidate = _m[1].toLowerCase();
        if (_candidate.slice(0,2) !== 'de') BASE_URL = '/' + _candidate;
      }
    } catch(_e){}
  }
  function url(path){
    if (!path) return path;
    if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0 || path.indexOf('//') === 0) return path;
    if (path.charAt(0) !== '/') path = '/' + path;
    if (!BASE_URL) return path;
    if (path.indexOf(BASE_URL + '/') === 0) return path;
    return BASE_URL + path;
  }

  /* ---- EN mapping (only loaded in EN locale) ----
     Maps the German source strings used in DATA[] (and a few UI literals)
     to their English equivalents. T(str) returns the EN string if available,
     otherwise the original string (so brand names / codes pass through). */
  var EN = IS_EN ? {
    // Categories
    'Premium - 4-in-1': 'Premium - 4-in-1',
    'Balance - Selbstbalancierend': 'Balance - Self-balancing',
    'Smart - Follow & App': 'Smart - Follow & App',
    'Komfort - mit Sitz': 'Comfort - with seat',
    'Carbon - Premium-Leicht': 'Carbon - Premium light',
    'Einstieg - Aluminium': 'Entry - Aluminium',
    'Follow - Remote': 'Follow - Remote',
    'Bag - 2-in-1': 'Bag - 2-in-1',
    'Reise - Travelcover': 'Travel - Travelcover',
    'Lifestyle - Outdoor': 'Lifestyle - Outdoor',

    // Taglines
    'Stand-Up - E-Trolley - Auto-Cruise - Faltgerät': 'Stand-Up - E-trolley - Auto-cruise - Foldable',
    'Selbstbalancierender Stand-Scooter mit 19-Zoll-Reifen': 'Self-balancing stand scooter with 19-inch tyres',
    'Folge-Trolley mit Fernbedienung, App-Steuerung & UWB': 'Follow trolley with remote, app control & UWB',
    'Elektrischer Golfwagen mit Sitz & 4-Rad-Fahrwerk': 'Electric golf cart with seat & 4-wheel chassis',
    'Leichter Carbon-Trolley mit Fernbedienung': 'Lightweight carbon trolley with remote',
    'Klassischer Elektro-Trolley mit Lithium-Akku': 'Classic electric trolley with lithium battery',
    'Follow-Trolley mit Fernbedienung': 'Follow trolley with remote',
    '2-in-1 Golftasche mit integriertem Trolley': '2-in-1 golf bag with integrated trolley',
    'Faltbares Golf-Travelcover mit Rollen & Hartschale': 'Foldable golf travel cover with wheels & hard shell',
    'Mobile Strand-Kopfstuetze mit Sonnenblende': 'Mobile beach head support with sun visor',

    // Gauge labels
    'Top-Speed': 'Top speed',
    'Reichweite': 'Range',
    'Antrieb': 'Drive',
    'Speed': 'Speed',
    'Fahrstufen': 'Speed levels',

    // Gauge units
    'km/h': 'km/h',
    'km': 'km',
    'W': 'W',
    'Loch': 'holes',
    'Stufen': 'levels',

    // Features
    'Gyro-Stabilisierung': 'Gyro stabilisation',
    'One-Click-Falten': 'One-click folding',
    'Regenschirm inkl.': 'Umbrella incl.',
    'Auto-Cruise-Modus': 'Auto-cruise mode',
    'Selbstbalancierend': 'Self-balancing',
    '19-Zoll-Offroad-Reifen': '19-inch off-road tyres',
    'Digital-Display': 'Digital display',
    'Aluminiumrahmen': 'Aluminium frame',
    'UWB Follow': 'UWB follow',
    'iOS & Android App': 'iOS & Android app',
    'Auto Brake': 'Auto brake',
    'Schubhilfe & Cruise': 'Push assist & cruise',
    'Komfortsitz mit Armlehnen': 'Comfort seat with armrests',
    '4-Rad-Fahrwerk': '4-wheel chassis',
    'Rueckwaertsgang': 'Reverse gear',
    'Hupe & Frontlicht': 'Horn & front light',
    '3K Carbon-Rahmen': '3K carbon frame',
    'Fernbedienung': 'Remote control',
    'Slim-Fold': 'Slim fold',
    '9 Geschwindigkeitsstufen': '9 speed levels',
    'Aluminium-Rahmen': 'Aluminium frame',
    'Follow-System': 'Follow system',
    'Schubhilfe': 'Push assist',
    'Remote-Modi': 'Remote modes',
    '2-in-1 System': '2-in-1 system',
    'One-Click-Stand': 'One-click stand',
    'XL-Räder': 'XL wheels',
    'Teleskopgriff': 'Telescoping handle',
    'ABS-Hartschale (Top)': 'ABS hard shell (top)',
    'Nylon-Body, faltbar': 'Nylon body, foldable',
    'Zahlenschloss': 'Combination lock',
    'Wasserabweisend': 'Water-repellent',
    'Echtholz': 'Real wood',
    'Integrierte Sonnenblende': 'Integrated sun visor',
    'Faltbar (ca. 8 cm Höhe)': 'Foldable (approx. 8 cm height)',
    'Baumwoll-Textil': 'Cotton textile',

    // Metric labels
    'Akku': 'Battery',
    'Ladezeit': 'Charging time',
    'Steigfähigkeit': 'Gradeability',
    'Eigengewicht': 'Own weight',
    'Nutzergewicht': 'User weight',
    'Bereifung': 'Tyres',
    'Steuerung': 'Control',
    'Räder': 'Wheels',
    'Modi': 'Modes',
    'Bauart': 'Type',
    'Sitz': 'Seat',
    'Wendekreis': 'Turning radius',
    'Stufen': 'Levels',
    'Rahmen': 'Frame',
    'Zuladung': 'Payload',
    'Gewicht': 'Weight',
    'Schläger': 'Clubs',
    'Material': 'Material',
    'Gefaltet': 'Folded',
    'Schloss': 'Lock',
    'Schutz': 'Protection',
    'Sonnenblende': 'Sun visor',

    // Metric values
    '48 V / 20 Ah': '48 V / 20 Ah',
    '960 Wh - Li-Ion entnehmbar': '960 Wh - Li-ion removable',
    '55,5 V / 21 Ah': '55.5 V / 21 Ah',
    'Li-Ion entnehmbar': 'Li-ion removable',
    '4-7 h': '4-7 h',
    '19" Offroad': '19" off-road',
    'Luftreifen': 'Pneumatic tyres',
    'Brushless 2.400 W': 'Brushless 2,400 W',
    'Elektronisch': 'Electronic',
    'Auto-Balance': 'Auto-balance',
    'an 230 V Steckdose': 'from a 230 V socket',
    'inkl. Akku': 'incl. battery',
    'bis 160 kg': 'up to 160 kg',
    'High Performance': 'High performance',
    '10" Luftreifen': '10" pneumatic tyres',
    'Anti-Slip-Profil': 'Anti-slip tread',
    '25,2 V / 10,4 Ah': '25.2 V / 10.4 Ah',
    '262 Wh - entnehmbar': '262 Wh - removable',
    '5 h': '5 h',
    'Remote ca. 2,5 h': 'Remote approx. 2.5 h',
    'bis 20 Grad': 'up to 20 degrees',
    '4-Rad-Stabilität': '4-wheel stability',
    '18,5 kg': '18.5 kg',
    '+ 1,8 kg Akku': '+ 1.8 kg battery',
    'bis 50 m': 'up to 50 m',
    'Joystick + App': 'Joystick + app',
    '8 Räder': '8 wheels',
    'Doppel-Lenkrollen vorn': 'Dual castors at front',
    '36 V Lithium': '36 V lithium',
    'Kapazität konfig.-abh.': 'Capacity config-dependent',
    '5-8 h': '5-8 h',
    'an 230 V': 'from a 230 V socket',
    'I - II - III': 'I - II - III',
    '6 / 12 / 18 km/h': '6 / 12 / 18 km/h',
    '24 V / 10 Ah': '24 V / 10 Ah',
    'Lithium-Ionen': 'Lithium-ion',
    'bis 30 Grad': 'up to 30 degrees',
    'Premium-Schub': 'Premium thrust',
    '~ 8,5 kg': '~ 8.5 kg',
    'bis 30 kg': 'up to 30 kg',
    'Bag + Zubehör': 'Bag + accessories',
    'Griff + Fernbed.': 'Handle + remote',
    '9 Stufen': '9 levels',
    '3K Carbon': '3K carbon',
    'leicht + steif': 'light + stiff',
    '~ 8,0 kg': '~ 8.0 kg',
    'Slim Fold': 'Slim fold',
    'bis 25 kg': 'up to 25 kg',
    'Aluminium': 'Aluminium',
    'leicht + robust': 'light + robust',
    'Follow + Remote': 'Follow + remote',
    'Joystick-Modul': 'Joystick module',
    'Follow / Remote / Schubhilfe': 'Follow / remote / push assist',
    'flexibel': 'flexible',
    'siehe Anleitung': 'see manual',
    'Mehrrad': 'Multi-wheel',
    'Stabilitäts-Layout': 'Stability layout',
    '~ 5,5 kg': '~ 5.5 kg',
    'leicht zu tragen': 'easy to carry',
    'mind. 14': 'at least 14',
    'sortiert verstaubar': 'sorted storage',
    'XL ~ 11 cm': 'XL ~ 11 cm',
    'leichtes Rollen': 'smooth rolling',
    '~ 3,3 kg': '~ 3.3 kg',
    'leicht für lange Reisen': 'light for long trips',
    'ABS + Nylon': 'ABS + nylon',
    'Hartschale + flex Body': 'Hard shell + flex body',
    'Reissverschluss-Sicherung': 'Zipper security',
    'nicht wasserdicht': 'not waterproof',
    '~ 1,8 kg': '~ 1.8 kg',
    'Pocket-Format': 'Pocket format',
    '~ 8 cm Höhe': '~ 8 cm height',
    'integriert': 'integrated',
    'Schatten für Kopfpartie': 'Shade for the head area',

    // Dimensions labels
    'Masse - Betrieb & Packmass': 'Dimensions - in use & packed',
    'Masse - Fahrzeug & Faltmass': 'Dimensions - vehicle & folded',
    'Masse': 'Dimensions',

    // Dimension item names
    'Betriebsmass': 'In use',
    'Packmass': 'Packed',
    'Fahrzeug': 'Vehicle',
    'Faltmass': 'Folded',
    'Bag': 'Bag',
    'Außenmaß': 'External',
    'Aufgebaut': 'Set up',
    'Gefaltet ': 'Folded ',

    // Safety
    'Auto-Stop bei Signalverlust': 'Auto-stop on signal loss',
    'Auto-Stop': 'Auto-stop',
    'Verstaerkter Top': 'Reinforced top',
    'Rollen': 'Wheels',
    'Klemmschutz-Hinweise': 'Pinch protection notes',
    'Auto Balance': 'Auto balance',
    'Slope Control': 'Slope control',
    'Tragegurt': 'Carry strap',
    'Standmechanik': 'Stand mechanism',
    'Reissverschluesse': 'Zippers',
    'IP67 (Komponenten)': 'IP67 (components)',

    // GOOTER 2400 (Sitz+Stehen)
    'Sitzen & Stehen - 4-Rad-Scooter': 'Sit & stand - 4-wheel scooter',
    '4-Rad-Golf-Scooter mit Sitz- und Stehfunktion': '4-wheel golf scooter with seat and standing function',
    'Sitzen oder stehen': 'Sit or stand',
    'Golfbag-Traegerplatte vorne': 'Front golf-bag carrier plate',
    '10-Zoll-Luftreifen': '10-inch pneumatic tyres',
    'Faltbar und zerlegbar': 'Foldable and separable',
    '960 Wh, entnehmbar': '960 Wh, removable',
    'Zuladung': 'Max. load',
    'bis 160 kg': 'up to 160 kg',
    'Fahrer + Golfbag': 'rider + golf bag',
    '10" Luftreifen': '10" pneumatic',
    'mit Schlauch': 'with tube',
    'Bodenfreiheit': 'Ground clearance',
    'gelaendetauglich': 'terrain-ready',
    'Fahrstufen': 'Speed levels',
    'drei Stufen': 'three levels',
    'Scheibenbremse': 'Disc brake',
    'Feststellbremse': 'Parking brake',
    'LED + Bremslicht': 'LED + brake light',
    'Hupe': 'Horn',
    // Update 05.10.2026 (facts.json)
    'Sitz inklusive': 'Seat included',
    'Frontkorb inklusive': 'Front basket included',
    'ca. 6-8 h': 'approx. 6-8 h',
    'bis 20°': 'up to 20°',
    'bis 30°': 'up to 30°',
    'bis 35°': 'up to 35°',
    'Herstellerangabe': 'manufacturer specification',
    'Hänge vorsichtig befahren': 'approach slopes with care',
    '28 / 33 kg': '28 / 33 kg',
    'ohne / mit Akku': 'without / with battery',
    'Gesamtlast': 'Total load',
    'Person + Zuladung': 'person + payload',
    'Gesamtzuladung': 'Total payload',
    'Golfbag-Aufnahme inklusive': 'Golf bag mount included',
    'ca. 52 kg': 'approx. 52 kg',
    'nur eine Person': 'one person only',
    'ca. 30 kg': 'approx. 30 kg',
    'ohne Akku, Akku ca. 5 kg': 'without battery, battery approx. 5 kg',
    'Elektronisches Bremssystem': 'Electronic braking system',
    'ca. 18,5 kg': 'approx. 18.5 kg',
    'ohne Akku, Akku ca. 1,8 kg': 'without battery, battery approx. 1.8 kg',
    'Faltmass (ohne Sitzkissen)': 'Folded (without seat cushion)',
    'Gefaltet (ohne Sitz)': 'Folded (without seat)',
    'Gefaltet (ohne Akku)': 'Folded (without battery)',
    'Verpackt': 'Packaged',
    'Nach Quick-Release': 'After quick release',
    'Masse - Betrieb, Faltmass & Verpackung': 'Dimensions - in use, folded & packaging',
    'Masse - Betrieb, Faltmass & Packmass': 'Dimensions - in use, folded & packed',
    'Masse - Betrieb, Faltmass & Quick-Release': 'Dimensions - in use, folded & after quick release',
    '36 V / 30 Ah': '36 V / 30 Ah',
    'Lithium, entnehmbar': 'Lithium, removable',
    'ca. 46 kg': 'approx. 46 kg',
    'mit Akku und Sitz': 'with battery and seat',
    'Traglast': 'Load capacity',
    'bis 180 kg': 'up to 180 kg',
    'Gesamtbelastung': 'total load',
    '4 × 300 W': '4 × 300 W',
    'Allradantrieb': 'All-wheel drive',
    'Elektronische Motorbremse': 'Electronic motor brake',
    'Mechanische Bremse': 'Mechanical brake',
    'Parkbremse': 'Parking brake',
    'Motorbremse': 'Motor brake',
    'ca. 8 / 9,5 kg': 'approx. 8 / 9.5 kg',
    '25,2 V / 7,8 Ah': '25.2 V / 7.8 Ah',
    'Lithium-Ionen, entnehmbar': 'Lithium-ion, removable',
    'ca. 14,9 kg': 'approx. 14.9 kg',
    'mit Akku': 'with battery',
    'bis 36 Loch': 'up to 36 holes',
    'Laden ca. 4 h': 'charging approx. 4 h',
    'ca. 5,5 kg': 'approx. 5.5 kg',
    'leer': 'empty',
    'Kunstleder (PU-Optik)': 'Faux leather (PU look)',
    'wasserabweisend': 'water-repellent',
    'Farben': 'Colours',
    'Weiß oder Schwarz': 'White or black',
    'Olive oder Beige': 'Olive or beige',
    'zur Wahl': 'to choose from',
    'Regenfeste Reißverschlüsse': 'Rain-resistant zippers',
    'Tipp': 'Tip',
    '2 Bags': '2 bags',
    'kleine Reise-Bags bis 7,7 Zoll': 'small travel bags up to 7.7 inches',
    'ca. 1,8 kg': 'approx. 1.8 kg',
    'ohne Kissen': 'without cushion',
    'ca. 8 cm Höhe': 'approx. 8 cm height',
    'mit Tragegurt': 'with carry strap',
    'Golfbag': 'Golf bag',
    // PDF meta
    'PDF - DE - 20 Seiten': 'PDF - DE - 20 pages',
    'PDF - DE - 16 Seiten': 'PDF - DE - 16 pages',
    'PDF - DE - 12 Seiten': 'PDF - DE - 12 pages',
    'PDF - DE - 8 Seiten': 'PDF - DE - 8 pages',
    'PDF - DE/EN - 12 Seiten': 'PDF - DE/EN - 12 pages',
    'PDF - DE': 'PDF - DE'
  } : {};

  function T(s){
    if (!IS_EN || s == null) return s;
    if (EN[s]) return EN[s];
    // Fallback: if string ends with " - DE" suffix etc., still return as-is
    return s;
  }

  /* ---- UI literals (used by render functions directly) ---- */
  var UI = IS_EN ? {
    counterOf: 'of',
    btnPdf: 'User manual as PDF',
    btnView: 'View product',
    safetyHead: 'Safety features',
    dimsSub: 'Dimensions in cm - manufacturer data, approx.'
  } : {
    counterOf: 'von',
    btnPdf: 'Bedienungsanleitung als PDF',
    btnView: 'Zum Produkt',
    safetyHead: 'Sicherheitsmerkmale',
    dimsSub: 'Maße in cm - Herstellerangaben, ca.'
  };

  var CDN = "https://cdn.shopify.com/s/files/1/0973/7437/2217/files/";

  var DATA = [
    { id:'cadpro', name:'E-CadPro', family:'caddy',
      image: CDN + "gooter-ecadpro-stand-up-fahren-fairway-1.jpg?v=1780031911&width=900",
      url:'/products/gooter-e-cadpro-elektrischer-golftrolley-zum-fahren',
      category:'Premium - 4-in-1',
      tagline:'Stand-Up - E-Trolley - Auto-Cruise - Faltgerät',
      color1:'#4f46e5', color2:'#7c3aed',
      pdf: CDN + (IS_EN ? "GOOTER_E-CadPro-StandUp_Manual_EN.pdf?v=1780238963" : "GOOTER_E-CadPro-StandUp_Bedienungsanleitung_DE.pdf?v=1780238963"),
      pdfMeta:(IS_EN ? 'PDF - EN' : 'PDF - DE'),
      features:['Gyro-Stabilisierung','One-Click-Falten','Regenschirm inkl.','Auto-Cruise-Modus'],
      gauges:[
        {label:'Top-Speed', value:25, max:25, unit:'km/h'},
        {label:'Reichweite', value:60, max:60, unit:'km'},
        {label:'Antrieb', value:1600, max:1600, unit:'W'}
      ],
      metrics:[
        {icon:'battery', label:'Akku', value:'48 V / 20 Ah', sub:'960 Wh - Li-Ion entnehmbar'},
        {icon:'charge', label:'Ladezeit', value:'ca. 6-8 h', sub:'an 230 V Steckdose'},
        {icon:'climb', label:'Steigfähigkeit', value:'bis 20°', sub:'Herstellerangabe'},
        {icon:'weight', label:'Gewicht', value:'28 / 33 kg', sub:'ohne / mit Akku'},
        {icon:'user', label:'Gesamtlast', value:'bis 160 kg', sub:'Person + Zuladung'},
        {icon:'tire', label:'Bereifung', value:'10" Luftreifen', sub:'Luftreifen'}
      ],
      dimensions:{label:'Masse - Betrieb, Faltmass & Verpackung', items:[
        {w:860, h:970, d:1140, name:'Aufgebaut'},
        {w:1050, h:543, d:390, name:'Gefaltet (ohne Akku)'},
        {w:580, h:410, d:1140, name:'Verpackt'}
      ]},
      safety:[]
    },
    { id:'balancepro', name:'BalancePro', family:'caddy',
      image: CDN + "gooter-balancepro-elektrischer-golf-scooter-fairway_0b120ab8-841b-4e60-bcd4-0e914e2bd027.jpg?v=1780119404&width=900",
      url:'/products/gooter-balancepro-elektrischer-golf-scooter',
      category:'Balance - Selbstbalancierend',
      tagline:'Selbstbalancierender Stand-Scooter mit 19-Zoll-Reifen',
      color1:'#dc2626', color2:'#991b1b',
      pdf:'',
      pdfMeta:'',
      features:['Selbstbalancierend','19-Zoll-Offroad-Reifen','Aluminiumrahmen','Digital-Display'],
      gauges:[
        {label:'Top-Speed', value:20, max:25, unit:'km/h'},
        {label:'Reichweite', value:35, max:60, unit:'km'},
        {label:'Antrieb', value:2400, max:2400, unit:'W'}
      ],
      metrics:[
        {icon:'battery', label:'Akku', value:'55,5 V / 21 Ah', sub:'Li-Ion entnehmbar'},
        {icon:'charge', label:'Ladezeit', value:'4-7 h', sub:'an 230 V Steckdose'},
        {icon:'climb', label:'Steigfähigkeit', value:'bis 35°', sub:'Hänge vorsichtig befahren'},
        {icon:'weight', label:'Gewicht', value:'ca. 52 kg', sub:'inkl. Akku'},
        {icon:'user', label:'Gesamtzuladung', value:'bis 160 kg', sub:'Golfbag-Aufnahme inklusive'},
        {icon:'tire', label:'Bereifung', value:'19" Offroad', sub:'Luftreifen'}
      ],
      dimensions:{label:'Masse', items:[
        {w:450, h:700, d:1000, name:'Aufgebaut'}
      ]},
      safety:['Auto-Balance','Elektronisches Bremssystem']
    },
    { id:'gooter2400', name:'Ecad SeatStand 3.0', family:'caddy',
      image: CDN + "gooter-golf-scooter-mit-sitz-golfbag-halterung.jpg?v=1786792869&width=900",
      url:'/products/gooter-ecad-seatstand-3-0-elektrischer-golf-scooter-mit-sitz',
      category:'Sitzen & Stehen - 4-Rad-Scooter',
      tagline:'4-Rad-Golf-Scooter mit Sitz- und Stehfunktion',
      color1:'#0e7490', color2:'#155e75',
      pdf: CDN + (IS_EN ? "GOOTER_2400_Manual_EN.pdf?v=1786793917" : "GOOTER_2400_Bedienungsanleitung_DE.pdf?v=1786793918"),
      pdfMeta:(IS_EN ? 'PDF - EN' : 'PDF - DE'),
      features:['Sitz inklusive','Sitzen oder stehen','Golfbag-Traegerplatte vorne','10-Zoll-Luftreifen','Faltbar und zerlegbar'],
      gauges:[
        {label:'Top-Speed', value:18, max:25, unit:'km/h'},
        {label:'Reichweite', value:50, max:60, unit:'km'},
        {label:'Antrieb', value:2400, max:2400, unit:'W'}
      ],
      metrics:[
        {icon:'battery', label:'Akku', value:'48 V / 20 Ah', sub:'960 Wh, entnehmbar'},
        {icon:'charge', label:'Ladezeit', value:'6-8 h', sub:'an 230 V Steckdose'},
        {icon:'user', label:'Zuladung', value:'bis 160 kg', sub:'nur eine Person'},
        {icon:'weight', label:'Gewicht', value:'ca. 30 kg', sub:'ohne Akku, Akku ca. 5 kg'},
        {icon:'climb', label:'Steigfähigkeit', value:'bis 20°', sub:'Herstellerangabe'},
        {icon:'speedchip', label:'Fahrstufen', value:'6/12/18 km/h', sub:'drei Stufen'}
      ],
      dimensions:{label:'Masse', items:[
        {w:1060, h:690, d:1180, name:'Aufgebaut'},
        {w:1060, h:690, d:450, name:'Gefaltet (ohne Sitz)'}
      ]},
      safety:['Scheibenbremse','Feststellbremse','LED + Bremslicht','Hupe']
    },
    { id:'followapppro', name:'E-Cad Follow App Pro', family:'caddy',
      image: CDN + "67866980647289-IMG-2177Golf_E-Cad_Follow_App_Pro_Golftrolley_elektrisch_Follow-System_App_Remote.jpg?v=1775104598&width=900",
      url:'/products/gooter-e-cad-follow-app-pro-elektrischer-golf-trolley-follow-system',
      category:'Smart - Follow & App',
      tagline:'Folge-Trolley mit Fernbedienung, App-Steuerung & UWB',
      color1:'#06b6d4', color2:'#3b82f6',
      pdf: CDN + (IS_EN ? "GOOTER_E-Cad-Follow-App-Pro_Manual_EN.pdf?v=1780238963" : "GOOTER_E-Cad-Follow-App-Pro_Bedienungsanleitung_DE.pdf?v=1780238963"),
      pdfMeta:(IS_EN ? 'PDF - EN' : 'PDF - DE'),
      features:['UWB Follow','iOS & Android App','Auto Brake','Schubhilfe & Cruise'],
      gauges:[
        {label:'Speed', value:7, max:25, unit:'km/h'},
        {label:'Reichweite', value:45, max:60, unit:'Loch'},
        {label:'Antrieb', value:160, max:1600, unit:'W'}
      ],
      metrics:[
        {icon:'battery', label:'Akku', value:'25,2 V / 10,4 Ah', sub:'262 Wh - entnehmbar'},
        {icon:'charge', label:'Ladezeit', value:'5 h', sub:'Remote ca. 2,5 h'},
        {icon:'climb', label:'Steigfähigkeit', value:'bis 20°', sub:'Herstellerangabe'},
        {icon:'weight', label:'Gewicht', value:'ca. 18,5 kg', sub:'ohne Akku, Akku ca. 1,8 kg'},
        {icon:'remote', label:'Fernbedienung', value:'bis 50 m', sub:'Joystick + App'},
        {icon:'tire', label:'Räder', value:'8 Räder', sub:'Doppel-Lenkrollen vorn'}
      ],
      dimensions:{label:'Masse - Betrieb, Faltmass & Packmass', items:[
        {w:744, h:630, d:1293, name:'Betriebsmass'},
        {w:732, h:630, d:368, name:'Faltmass'},
        {w:790, h:620, d:410, name:'Packmass'}
      ]},
      safety:['UWB','Auto Brake','Auto Balance','Slope Control']
    },
    { id:'cruiserpro', name:'E-CadCruiser Pro', family:'caddy',
      image: CDN + "67870000972153-IMG-2226Elektrischer_Golfwagen_mit_Sitz_und_faltbarem_Design.jpg?v=1775104573&width=900",
      url:'/products/elektrischer-golfwagen-mit-sitz-faltbar',
      category:'Komfort - mit Sitz',
      tagline:'Elektrischer Golfwagen mit Sitz & 4-Rad-Fahrwerk',
      color1:'#0891b2', color2:'#0e7490',
      pdf: CDN + (IS_EN ? "GOOTER_E-CadCruiser-Pro_Manual_EN.pdf?v=1780238963" : "GOOTER_E-CadCruiser-Pro_Bedienungsanleitung_DE.pdf?v=1780238963"),
      pdfMeta:(IS_EN ? 'PDF - EN' : 'PDF - DE'),
      features:['Komfortsitz mit Armlehnen','Frontkorb inklusive','4-Rad-Fahrwerk','Rueckwaertsgang','Hupe & Frontlicht'],
      gauges:[
        {label:'Top-Speed', value:18, max:25, unit:'km/h'},
        {label:'Reichweite', value:45, max:60, unit:'km'},
        {label:'Fahrstufen', value:3, max:3, unit:'Stufen', display:'integer'}
      ],
      metrics:[
        {icon:'battery', label:'Akku', value:'36 V / 30 Ah', sub:'Lithium, entnehmbar'},
        {icon:'charge', label:'Ladezeit', value:'5-8 h', sub:'an 230 V'},
        {icon:'speedchip', label:'Fahrstufen', value:'I - II - III', sub:'6 / 12 / 18 km/h'},
        {icon:'weight', label:'Gewicht', value:'ca. 46 kg', sub:'mit Akku und Sitz'},
        {icon:'user', label:'Traglast', value:'bis 180 kg', sub:'Gesamtbelastung'},
        {icon:'gear', label:'Antrieb', value:'4 × 300 W', sub:'Allradantrieb'}
      ],
      dimensions:{label:'Masse - Fahrzeug & Faltmass', items:[
        {w:1090, h:580, d:850, name:'Fahrzeug'},
        {w:420, h:580, d:760, name:'Faltmass (ohne Sitzkissen)'}
      ]},
      safety:['Elektronische Motorbremse','Mechanische Bremse','Parkbremse']
    },
    { id:'carbonremote', name:'E-CadLight Carbon-Remote', family:'caddy',
      image: CDN + "gooter-ecadlight-carbon-remote-seitlich.jpg?v=1780032107&width=900",
      url:'/products/gooter-e-cadlight-carbon-remote-golftrolley-fernbedienung',
      category:'Carbon - Premium-Leicht',
      tagline:'Leichter Carbon-Trolley mit Fernbedienung',
      color1:'#0ea5e9', color2:'#0284c7',
      pdf: CDN + (IS_EN ? "GOOTER_E-CadLight-Carbon-Remote_Manual_EN.pdf?v=1780238963" : "GOOTER_E-CadLight-Carbon-Remote_Bedienungsanleitung_DE.pdf?v=1780238963"),
      pdfMeta:(IS_EN ? 'PDF - EN' : 'PDF - DE'),
      features:['3K Carbon-Rahmen','Fernbedienung','Slim-Fold','9 Geschwindigkeitsstufen'],
      gauges:[
        {label:'Top-Speed', value:12, max:25, unit:'km/h'},
        {label:'Reichweite', value:20, max:60, unit:'km'},
        {label:'Antrieb', value:400, max:1600, unit:'W'}
      ],
      metrics:[
        {icon:'battery', label:'Akku', value:'24 V / 10 Ah', sub:'Lithium-Ionen'},
        {icon:'climb', label:'Steigfähigkeit', value:'bis 30°', sub:'Herstellerangabe'},
        {icon:'weight', label:'Eigengewicht', value:'~ 8,5 kg', sub:'inkl. Akku'},
        {icon:'user', label:'Zuladung', value:'bis 30 kg', sub:'Golfbag'},
        {icon:'remote', label:'Steuerung', value:'Griff + Fernbed.', sub:'9 Stufen'},
        {icon:'material', label:'Rahmen', value:'3K Carbon', sub:'leicht + steif'}
      ],
      dimensions:null,
      safety:['Auto-Stop bei Signalverlust']
    },
    { id:'cadone', name:'E-CadOne', family:'caddy',
      image: CDN + "gooter-ecadone-golf-trolley-fairway.jpg?v=1779978351&width=900",
      url:'/products/gooter-e-cadone-elektrischer-golf-trolley-mit-lithium-akku',
      category:'Einstieg - Aluminium',
      tagline:'Klassischer Elektro-Trolley mit Lithium-Akku',
      color1:'#10b981', color2:'#059669',
      pdf: CDN + (IS_EN ? "GOOTER_E-CadOne_Manual_EN.pdf?v=1780238963" : "GOOTER_E-CadOne_Bedienungsanleitung_DE_58d4c611-690d-4366-bc0b-f8a56b6382e2.pdf?v=1780238963"),
      pdfMeta:(IS_EN ? 'PDF - EN' : 'PDF - DE'),
      features:['Aluminium-Rahmen','9 Geschwindigkeitsstufen','Motorbremse','Slim-Fold'],
      gauges:[
        {label:'Top-Speed', value:10, max:25, unit:'km/h'},
        {label:'Reichweite', value:20, max:60, unit:'km'},
        {label:'Antrieb', value:180, max:1600, unit:'W'}
      ],
      metrics:[
        {icon:'battery', label:'Akku', value:'24 V / 10 Ah', sub:'Lithium-Ionen'},
        {icon:'climb', label:'Steigfähigkeit', value:'bis 30°', sub:'Herstellerangabe'},
        {icon:'weight', label:'Gewicht', value:'ca. 8 / 9,5 kg', sub:'ohne / mit Akku'},
        {icon:'user', label:'Zuladung', value:'bis 25 kg', sub:'Golfbag'},
        {icon:'material', label:'Rahmen', value:'Aluminium', sub:'leicht + robust'},
        {icon:'gear', label:'Stufen', value:'9 Stufen', sub:'Motorbremse'}
      ],
      dimensions:{label:'Masse', items:[
        {w:1000, h:700, d:600, name:'Aufgebaut'}
      ]},
      safety:['Auto-Stop','Motorbremse']
    },
    { id:'followlight', name:'E-CadFollow Light', family:'caddy',
      image: CDN + "68466656182649-Golf-ECad-Follow-light1.jpg?v=1778969411&width=900",
      url:'/products/gooter-e-cadfollow-light-golftrolley-follow-fernbedienung',
      category:'Follow - Remote',
      tagline:'Follow-Trolley mit Fernbedienung',
      color1:'#8b5cf6', color2:'#a78bfa',
      pdf: CDN + (IS_EN ? "GOOTER_E-CadFollow-Light_Manual_EN.pdf?v=1780238962" : "GOOTER_E-CadFollow-Light_Bedienungsanleitung_DE.pdf?v=1780238963"),
      pdfMeta:(IS_EN ? 'PDF - EN' : 'PDF - DE'),
      features:['Follow-System','Fernbedienung','Schubhilfe','Remote-Modi'],
      gauges:[],
      metrics:[
        {icon:'remote', label:'Steuerung', value:'Follow + Remote', sub:'Joystick-Modul'},
        {icon:'gear', label:'Modi', value:'Follow / Remote / Schubhilfe', sub:'flexibel'},
        {icon:'battery', label:'Akku', value:'25,2 V / 7,8 Ah', sub:'Lithium-Ionen, entnehmbar'},
        {icon:'weight', label:'Gewicht', value:'ca. 14,9 kg', sub:'mit Akku'},
        {icon:'gear', label:'Reichweite', value:'bis 36 Loch', sub:'Laden ca. 4 h'},
        {icon:'climb', label:'Steigfähigkeit', value:'bis 20°', sub:'Herstellerangabe'}
      ],
      dimensions:{label:'Masse - Betrieb, Faltmass & Quick-Release', items:[
        {w:900, h:600, d:1160, name:'Aufgebaut'},
        {w:900, h:600, d:380, name:'Gefaltet'},
        {w:620, h:590, d:300, name:'Nach Quick-Release'}
      ]},
      safety:['Auto-Stop']
    },
    { id:'hybridbag', name:'Hybrid Bag', family:'bag',
      image: CDN + "gooter-hybrid-bag-golftasche-mit-trolley-schwarz.jpg?v=1780032270&width=900",
      url:'/products/gooter-hybrid-bag-2-in-1-golftasche-mit-trolley',
      category:'Bag - 2-in-1',
      tagline:'2-in-1 Golftasche mit integriertem Trolley',
      color1:'#f59e0b', color2:'#d97706',
      pdf: CDN + (IS_EN ? "GOOTER_Hybrid-Bag_Manual_EN.pdf?v=1780238962" : "GOOTER_Hybrid-Bag_Kurzanleitung_DE.pdf?v=1780238963"),
      pdfMeta:(IS_EN ? 'PDF - EN' : 'PDF - DE'),
      features:['2-in-1 System','One-Click-Stand','XL-Räder','Teleskopgriff'],
      gauges:[],
      metrics:[
        {icon:'weight', label:'Gewicht', value:'ca. 5,5 kg', sub:'leer'},
        {icon:'clubs', label:'Schläger', value:'mind. 14', sub:'sortiert verstaubar'},
        {icon:'tire', label:'Räder', value:'XL ~ 11 cm', sub:'leichtes Rollen'},
        {icon:'material', label:'Material', value:'Kunstleder (PU-Optik)', sub:'wasserabweisend'},
        {icon:'shield', label:'Farben', value:'Weiß oder Schwarz', sub:'zur Wahl'}
      ],
      dimensions:{label:'Masse', items:[
        {w:920, h:220, d:280, name:'Bag'}
      ]},
      safety:['Regenfeste Reißverschlüsse','Standmechanik','Tragegurt']
    },
    { id:'travelcase', name:'Travel Hard Case', family:'bag',
      image: CDN + "68261632770425-GOOTER_GolfTravelHardCase_faltbareReise-GolftaschemitRollen4.jpg?v=1777497306&width=900",
      url:'/products/gooter-travel-hard-case-golf-travelcover-mit-rollen',
      category:'Reise - Travelcover',
      tagline:'Faltbares Golf-Travelcover mit Rollen & Hartschale',
      color1:'#374151', color2:'#1f2937',
      pdf: CDN + (IS_EN ? "GOOTER_Travel-Hard-Case_Manual_EN.pdf?v=1780238963" : "GOOTER_Travel-Hard-Case_Bedienungsanleitung_DE.pdf?v=1780238963"),
      pdfMeta:(IS_EN ? 'PDF - EN' : 'PDF - DE'),
      features:['ABS-Hartschale (Top)','Nylon-Body, faltbar','Zahlenschloss','Wasserabweisend'],
      gauges:[],
      metrics:[
        {icon:'weight', label:'Gewicht', value:'~ 3,3 kg', sub:'leicht für lange Reisen'},
        {icon:'shield', label:'Material', value:'ABS + Nylon', sub:'Hartschale + flex Body'},
        {icon:'lock', label:'Schloss', value:'Zahlenschloss', sub:'Reissverschluss-Sicherung'},
        {icon:'wave', label:'Schutz', value:'Wasserabweisend', sub:'nicht wasserdicht'},
        {icon:'clubs', label:'Tipp', value:'2 Bags', sub:'kleine Reise-Bags bis 7,7 Zoll'}
      ],
      dimensions:{label:'Masse', items:[
        {w:1300, h:380, d:320, name:'Außenmaß'},
        {w:350, h:380, d:320, name:'Gefaltet'}
      ]},
      safety:['Zahlenschloss','Verstaerkter Top','Rollen']
    },
    { id:'sunbeachy', name:'SunBeachy', family:'lifestyle',
      image: CDN + "68195132834169-IMG-2682.png?v=1777497293&width=900",
      url:'/products/strand-kopfstuetze-mit-sonnenblende',
      category:'Lifestyle - Outdoor',
      tagline:'Mobile Strand-Kopfstuetze mit Sonnenblende',
      color1:'#eab308', color2:'#ca8a04',
      pdf: CDN + (IS_EN ? "GOOTER_SunBeachy_Manual_EN.pdf?v=1780238963" : "GOOTER_SunBeachy_Bedienungsanleitung_DE.pdf?v=1780238963"),
      pdfMeta:(IS_EN ? 'PDF - EN' : 'PDF - DE'),
      features:['Echtholz','Integrierte Sonnenblende','Faltbar (ca. 8 cm Höhe)','Baumwoll-Textil'],
      gauges:[],
      metrics:[
        {icon:'weight', label:'Gewicht', value:'ca. 1,8 kg', sub:'ohne Kissen'},
        {icon:'fold', label:'Gefaltet', value:'ca. 8 cm Höhe', sub:'mit Tragegurt'},
        {icon:'material', label:'Rahmen', value:'Echtholz'},
        {icon:'sun', label:'Sonnenblende', value:'integriert', sub:'Schatten für Kopfpartie'},
        {icon:'material', label:'Farben', value:'Olive oder Beige', sub:'zur Wahl'}
      ],
      dimensions:{label:'Masse', items:[
        {w:450, h:400, d:350, name:'Aufgebaut'}
      ]},
      safety:['Klemmschutz-Hinweise']
    }
  ];

  var ORDER = ['cadpro','gooter2400','balancepro','followapppro','cruiserpro','carbonremote','cadone','followlight','hybridbag','travelcase','sunbeachy'];
  var byId = {};
  DATA.forEach(function(p){ byId[p.id] = p; });

  var ICONS = {
    battery:'<svg viewBox="0 0 24 24" fill="none"><rect x="3" y="7" width="16" height="10" rx="1.5" stroke="currentColor" stroke-width="1.7"/><rect x="19.5" y="9.5" width="2" height="5" rx=".7" fill="currentColor"/><path d="M6 10 H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    charge:'<svg viewBox="0 0 24 24" fill="none"><path d="M13 2 L5 13 H11 L9 22 L19 9 H13 Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>',
    climb:'<svg viewBox="0 0 24 24" fill="none"><path d="M3 19 L9 9 L13 14 L17 8 L21 19 Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="17" cy="5" r="1.5" fill="currentColor"/></svg>',
    weight:'<svg viewBox="0 0 24 24" fill="none"><path d="M4 20 L6 7 H18 L20 20 Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="12" cy="7" r="2.5" stroke="currentColor" stroke-width="1.7"/></svg>',
    user:'<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="7.5" r="3.5" stroke="currentColor" stroke-width="1.7"/><path d="M4.5 20 C4.5 16 7.5 13.5 12 13.5 C16.5 13.5 19.5 16 19.5 20" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    tire:'<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.7"/></svg>',
    remote:'<svg viewBox="0 0 24 24" fill="none"><rect x="8" y="3" width="8" height="18" rx="1.6" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="7" r="1.2" fill="currentColor"/><path d="M10 11 H14 M10 13.5 H14 M10 16 H14 M10 18.5 H14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
    gear:'<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6"/><path d="M12 3 L12 6 M12 18 L12 21 M3 12 L6 12 M18 12 L21 12 M5.6 5.6 L7.7 7.7 M16.3 16.3 L18.4 18.4 M18.4 5.6 L16.3 7.7 M7.7 16.3 L5.6 18.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    speedchip:'<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/></svg>',
    seat:'<svg viewBox="0 0 24 24" fill="none"><path d="M5 14 L5 6 A2 2 0 0 1 7 4 L13 4 A2 2 0 0 1 15 6 L15 14 Z" stroke="currentColor" stroke-width="1.6"/><path d="M5 14 L19 14 L18 19 L7 19 Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    turn:'<svg viewBox="0 0 24 24" fill="none"><path d="M5 11 A7 5 0 0 1 19 11" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M16 14 L19 11 L16 8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    clubs:'<svg viewBox="0 0 24 24" fill="none"><path d="M9 4 L9 17 M15 4 L15 17 M7 17 L17 17 L17 20 L7 20 Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    material:'<svg viewBox="0 0 24 24" fill="none"><path d="M4 6 L12 3 L20 6 L20 18 L12 21 L4 18 Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M12 3 L12 21 M4 6 L20 6" stroke="currentColor" stroke-width="1.2" opacity=".6"/></svg>',
    fold:'<svg viewBox="0 0 24 24" fill="none"><path d="M4 15 L4 8 L12 4 L20 8 L20 15 L12 19 Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    sun:'<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.7"/><path d="M12 2 V5 M12 19 V22 M2 12 H5 M19 12 H22 M5 5 L7 7 M17 17 L19 19 M19 5 L17 7 M7 17 L5 19" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    shield:'<svg viewBox="0 0 24 24" fill="none"><path d="M12 2 L20 5 V11 C20 16 16 20 12 22 C8 20 4 16 4 11 V5 Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    lock:'<svg viewBox="0 0 24 24" fill="none"><rect x="5" y="10" width="14" height="11" rx="1.6" stroke="currentColor" stroke-width="1.7"/><path d="M8 10 V7 A4 4 0 1 1 16 7 V10" stroke="currentColor" stroke-width="1.7"/></svg>',
    wave:'<svg viewBox="0 0 24 24" fill="none"><path d="M3 10 C5 8 7 8 9 10 C11 12 13 12 15 10 C17 8 19 8 21 10" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M3 15 C5 13 7 13 9 15 C11 17 13 17 15 15 C17 13 19 13 21 15" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    download:'<svg viewBox="0 0 16 16" fill="none"><path d="M8 2 V11 M4 7 L8 11 L12 7 M3 13 H13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    arrow:'<svg viewBox="0 0 16 16" fill="none"><path d="M3 8 H13 M9 4 L13 8 L9 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function init(root){
    var current = 0;
    var banner = root.querySelector('.banner');
    var tgl = banner.querySelector('.toggle');
    var heroEl = root.querySelector('[data-pw-hero]');
    var dimsEl = root.querySelector('[data-pw-dims]');
    var compEl = root.querySelector('[data-pw-compliance]');
    var ovEl = root.querySelector('[data-pw-overview]');
    var navEl = root.querySelector('[data-pw-nav]');

    tgl.addEventListener('click', function(){
      var open = banner.getAttribute('data-open') === 'true';
      banner.setAttribute('data-open', open ? 'false' : 'true');
      tgl.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (!open) requestAnimationFrame(animateGauges);
    });

    function renderNav(){
      navEl.innerHTML = ORDER.map(function(id, i){
        var p = byId[id];
        return '<button type="button" class="nav-chip" role="tab" aria-current="'+(i===current?'true':'false')+'" data-idx="'+i+'">'+
          '<span class="nc-cat">'+T(p.category)+'</span><span class="nc-name">'+p.name+'</span></button>';
      }).join('');
      navEl.querySelectorAll('.nav-chip').forEach(function(b){
        b.addEventListener('click', function(){ go(parseInt(b.dataset.idx,10)); });
      });
    }

    function renderHero(){
      var p = byId[ORDER[current]];
      heroEl.style.setProperty('--c1', p.color1);
      heroEl.style.setProperty('--c2', p.color2);
      var gaugesHtml = '';
      if (p.gauges && p.gauges.length){
        gaugesHtml = '<div class="gauges">' + p.gauges.map(function(g){
          return '<div class="gauge" data-value="'+g.value+'" data-max="'+g.max+'" data-display="'+(g.display||'number')+'">'+
            '<span class="g-label">'+T(g.label)+'</span>'+
            '<div class="g-svg"><svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><circle class="g-track" cx="60" cy="60" r="50"/><circle class="g-fill" cx="60" cy="60" r="50" stroke="url(#gg-'+p.id+')" transform="rotate(-225 60 60)" stroke-dasharray="'+(Math.PI*100*0.75)+' '+(Math.PI*100)+'" stroke-dashoffset="'+(Math.PI*100*0.75)+'"/><defs><linearGradient id="gg-'+p.id+'" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="'+p.color1+'"/><stop offset="1" stop-color="'+p.color2+'"/></linearGradient></defs></svg>'+
            '<div class="g-text"><span class="g-val">0</span><span class="g-unit">'+T(g.unit)+'</span></div></div></div>';
        }).join('') + '</div>';
      }
      var metricsHtml = (p.metrics||[]).map(function(m){
        return '<div class="metric"><div class="m-ic">'+(ICONS[m.icon]||ICONS.gear)+'</div><div class="m-text"><div class="m-lbl">'+T(m.label)+'</div><div class="m-val">'+T(m.value)+'</div>'+(m.sub?'<div class="m-sub">'+T(m.sub)+'</div>':'')+'</div></div>';
      }).join('');
      var featuresHtml = (p.features||[]).map(function(f){ return '<span class="feature-chip">'+T(f)+'</span>'; }).join('');
      heroEl.innerHTML =
        '<div class="hero-bg"></div>'+
        '<div class="hero-head">'+
          '<div><div class="h-eyebrow">'+T(p.category)+'</div><h3><span class="accent">'+p.name+'</span></h3><p class="h-tag">'+T(p.tagline)+'</p></div>'+
          '<div class="h-counter"><strong>'+String(current+1).padStart(2,'0')+'</strong>'+UI.counterOf+' '+String(ORDER.length).padStart(2,'0')+'</div>'+
        '</div>'+
        '<div class="hero-body">'+
          '<div class="visual"><div class="visual-art"><div class="ring r1"></div><div class="ring r2"></div><div class="blob"></div><img class="prod-img" src="'+p.image+'" alt="'+p.name+'" loading="lazy"></div><div class="visual-foot">'+featuresHtml+'</div></div>'+
          '<div class="data">'+gaugesHtml+'<div class="metrics">'+metricsHtml+'</div><div class="actions">'+(p.pdf?('<a class="gpw-btn primary" href="'+p.pdf+'" target="_blank" rel="noopener noreferrer">'+ICONS.download+' '+UI.btnPdf+'<span class="meta">'+T(p.pdfMeta)+'</span></a>'):'')+'<a class="gpw-btn ghost" href="'+url(p.url)+'">'+UI.btnView+' '+ICONS.arrow+'</a></div></div>'+
        '</div>';
    }

    function renderDims(){
      var p = byId[ORDER[current]];
      if (!p.dimensions){ dimsEl.innerHTML=''; dimsEl.style.display='none'; return; }
      dimsEl.style.display='';
      var fmtCm = function(v){ var r = (v/10).toFixed(v%10===0?0:1); return IS_EN ? r : r.replace('.', ','); };
      var items = p.dimensions.items.map(function(it){
        return '<li class="dims-item"><span class="di-name">'+T(it.name)+'</span><span class="di-vals">'+fmtCm(it.w)+'<span class="di-x">x</span>'+fmtCm(it.h)+'<span class="di-x">x</span>'+fmtCm(it.d)+'<span class="di-u">cm</span></span></li>';
      }).join('');
      dimsEl.innerHTML = '<div class="dims-row"><span class="dims-label">'+T(p.dimensions.label)+'</span><ul class="dims-list">'+items+'</ul><span class="dims-sub">'+UI.dimsSub+'</span></div>';
    }

    function renderCompliance(){
      var p = byId[ORDER[current]];
      if (!p.safety || !p.safety.length){ compEl.innerHTML=''; return; }
      compEl.innerHTML = '<strong>'+UI.safetyHead+'</strong>' + p.safety.map(function(s){ return '<span class="c-tag">'+T(s)+'</span>'; }).join('');
    }

    function renderOverview(){
      ovEl.innerHTML = ORDER.map(function(id, i){
        var p = byId[id];
        return '<a class="ov-card" data-idx="'+i+'" href="'+url(p.url)+'" aria-current="'+(i===current?'true':'false')+'"><div class="ov-info"><div class="on">'+p.name+'</div><div class="oc">'+T(p.category)+'</div></div>'+(p.pdf?('<button class="ov-dl" type="button" aria-label="PDF" data-pdf="'+p.pdf+'">'+ICONS.download+'</button>'):'')+'</a>';
      }).join('');
      ovEl.querySelectorAll('.ov-card').forEach(function(card){
        card.addEventListener('click', function(e){
          if (e.target.closest('.ov-dl')) return;
          e.preventDefault();
          go(parseInt(card.dataset.idx, 10));
        });
      });
      ovEl.querySelectorAll('.ov-dl').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          window.open(btn.dataset.pdf, '_blank', 'noopener,noreferrer');
        });
      });
    }

    function animateGauges(){
      heroEl.querySelectorAll('.gauge').forEach(function(g){
        var val = parseFloat(g.dataset.value);
        var max = parseFloat(g.dataset.max);
        var display = g.dataset.display || 'number';
        var fill = g.querySelector('.g-fill');
        var txt = g.querySelector('.g-val');
        var C = Math.PI * 100;
        var arc = C * 0.75;
        var ratio = Math.max(0, Math.min(1, val/max));
        var offset = arc - arc * ratio;
        fill.style.strokeDasharray = arc + ' ' + C;
        fill.style.strokeDashoffset = arc;
        requestAnimationFrame(function(){ fill.style.strokeDashoffset = offset; });
        countUp(txt, val, 900, display === 'integer');
      });
    }

    function countUp(el, target, dur, integer){
      var start = performance.now();
      function step(now){
        var t = Math.min(1, (now-start)/dur);
        var eased = 1 - Math.pow(1-t, 3);
        var v = target * eased;
        el.textContent = integer ? Math.round(v) : (target < 10 ? v.toFixed(1) : Math.round(v));
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = integer ? Math.round(target) : (Number.isInteger(target) ? target : target.toFixed(1));
      }
      requestAnimationFrame(step);
    }

    function go(idx){
      if (idx === current) return;
      if (idx < 0) idx = ORDER.length - 1;
      if (idx >= ORDER.length) idx = 0;
      heroEl.classList.add('is-leaving');
      setTimeout(function(){
        current = idx;
        renderHero(); renderDims(); renderCompliance();
        navEl.querySelectorAll('.nav-chip').forEach(function(c, i){ c.setAttribute('aria-current', i===current?'true':'false'); });
        ovEl.querySelectorAll('.ov-card').forEach(function(c, i){ c.setAttribute('aria-current', i===current?'true':'false'); });
        var active = navEl.querySelector('.nav-chip[aria-current="true"]');
        if (active && active.scrollIntoView) active.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
        heroEl.classList.remove('is-leaving');
        heroEl.classList.add('is-entering');
        requestAnimationFrame(function(){ heroEl.classList.remove('is-entering'); animateGauges(); });
      }, 280);
    }

    root.querySelector('[data-pw-prev]').addEventListener('click', function(){ go(current-1); });
    root.querySelector('[data-pw-next]').addEventListener('click', function(){ go(current+1); });
    document.addEventListener('keydown', function(e){
      if (banner.getAttribute('data-open') !== 'true') return;
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      if (e.key === 'ArrowLeft'){ e.preventDefault(); go(current-1); }
      if (e.key === 'ArrowRight'){ e.preventDefault(); go(current+1); }
    });

    renderNav(); renderHero(); renderDims(); renderCompliance(); renderOverview();
  }

  function boot(){
    document.querySelectorAll('[data-gooter-produktwelt]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
